// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1fzJh","selects":"Documents_selects__282Yn"};